import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { mapSiteProps } from './headerApiHelper';

class header {
    getAssetGroups(organizationsParams) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getAssetGroups);
        return RestManagerWithoutBaseUrl.post(endpoint, organizationsParams);
    }

    getSites(options) {
        const endpoint = formatEndpoint(endpoints.site.getSites);
        return RestManagerWithoutBaseUrl.post(endpoint, options)
            .then((sites) => mapSiteProps(sites));
    }

    getAvailableAssets(params) {
        const endpoint = formatEndpoint(endpoints.system.getAssetList, params);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }

    ciamSearchOrganization(params) {
        const endpoint = formatEndpoint(endpoints.system.ciamSearchOrganization, params);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }
}

export default new header();
